import getMapProjection from 'helpers/map/getMapProjection'
import getMapDimensions from 'helpers/map/getMapDimensions'

export default function determineLocationOfNewFloorPlan({ map, imageSize }) {
  const projection = getMapProjection(map)
  const mapDimensions = getMapDimensions(map)

  const viewPortVerticalCenter = mapDimensions.height / 2
  const viewPortHorizontalCenter = mapDimensions.width / 2

  const imgWidth = imageSize.width
  const imgHeight = imageSize.height
  const newImgWidth = mapDimensions.width * 0.50
  const imgRatio = newImgWidth / imgWidth
  const newImgHeight = imgHeight * imgRatio

  const top = viewPortVerticalCenter - newImgHeight / 2
  const bottom = viewPortVerticalCenter + newImgHeight / 2
  const left = viewPortHorizontalCenter - newImgWidth / 2
  const right = viewPortHorizontalCenter + newImgWidth / 2

  const nw = projection.fromContainerPixelToLatLng(new google.maps.Point(left, top))
  const se = projection.fromContainerPixelToLatLng(new google.maps.Point(right, bottom))
  return { nw: { lat: nw.lat(), lng: nw.lng() }, se: { lat: se.lat(), lng: se.lng() } }
}



// WEBPACK FOOTER //
// ./src/helpers/floorPlans/determineLocationOfNewFloorPlan.js